import { createFileRoute, Outlet } from '@tanstack/react-router';
import Loader from '../../components/Loader';
import CleaningAccessRefused from '../../features/environmental-cleaning/components/CleaningAccessRefused';
import { useCleaningAccess } from '../../features/environmental-cleaning/hooks/useCleaningAccess';

export const Route = createFileRoute('/_auth/environmental-cleaning')({
  component: RouteComponent,
});

function RouteComponent() {
  const access = useCleaningAccess();

  if (access.status === 'loading') {
    return <Loader />;
  }
  if (access.status === 'refused') {
    return <CleaningAccessRefused reason={access.reason} />;
  }
  return <Outlet />;
}
